'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React, { type MouseEvent, useCallback } from 'react';
import { Icons } from '@/shared/Icons/Icons';
import styles from './styles.module.css';

type ServerBackButtonProps = {
  href: string; // Fallback URL when there is no history
  text?: string;
  className?: string;
};

const ServerBackButton = ({
  href,
  text = 'Назад',
  className = '',
}: ServerBackButtonProps) => {
  const router = useRouter();

  const handleClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      // Use JS back navigation when possible; otherwise go to fallback href
      try {
        e.preventDefault();
        if (typeof window !== 'undefined') {
          const hasHistory = window.history.length > 1;
          if (hasHistory) {
            router.back();
            return;
          }
        }
        // No history or non-browser env: push to fallback href
        router.push(href || '/');
      } catch {
        // As a last resort, allow default navigation
        // (keeping anchor's default behavior)
        // Note: since we called preventDefault above, we need to manually navigate
        router.push(href || '/');
      }
    },
    [router, href],
  );

  return (
    <Link
      href={href}
      onClick={handleClick}
      className={`${styles.button} ${styles.white} ${styles.default} ${className}`}
    >
      <span className={styles.iconLeft}>
        <Icons.ArrowLeft width="16" />
      </span>
      {text && <span className={styles.text}>{text}</span>}
    </Link>
  );
};

export default ServerBackButton;
